import type { CustomJsonComponentConfig } from '@apps/websiteCustomJsonComponents/config';
import { createLazyComponentFromNamedExport } from '@shared/utils/createLazyComponent';
import { FormDisplayGrabber } from './FormDisplaySidebar';

// Lazy load view components
const FormDisplayAdd = createLazyComponentFromNamedExport(() => import(/* webpackChunkName: "content/websiteEditorFormDisplayAdd" */ './FormDisplaySidebar'), 'FormDisplayAdd');

const FormDisplayEdit = createLazyComponentFromNamedExport(
  () => import(/* webpackChunkName: "content/websiteEditorFormDisplayEdit" */ './components/FormDisplayEdit'),
  'FormDisplayEdit',
);

const FormDisplayGuest = createLazyComponentFromNamedExport(
  () => import(/* webpackChunkName: "content/websiteEditorFormDisplayGuest" */ './components/FormDisplayGuest'),
  'FormDisplayGuest',
);

export const FormDisplayConfig: CustomJsonComponentConfig = {
  schemaUrl: 'https://withjoy.com/assets/public/schemas/FormCustomComponentV1_0_0.json',
  componentType: 'FormDisplay',
  adminSidebarComponent: {
    addComponentView: FormDisplayAdd,
    dragComponentView: FormDisplayGrabber,
    editComponentView: FormDisplayEdit,
    createComponentView: FormDisplayEdit,
  },
  guestSiteComponent: FormDisplayGuest,
};
